var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "46px",
    viewBox: "0 0 51 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "homepage-first-implementation",
    transform: "translate(-169.000000, -1921.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s6-platform",
    transform: "translate(-1.000000, 1409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(120.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(0.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon5",
    transform: "translate(33.006920, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2676136,45.83 L5.72875,45.83 C2.56856318,45.83 0,43.2614368 0,40.10125 L0,5.72875 C0,2.56856318 2.56856318,0 5.72875,0 L44.2676136,0 C47.4278005,0 49.9963636,2.56856318 49.9963636,5.72875 L49.9963636,40.10125 C49.9963636,43.2614368 47.4278005,45.83 44.2676136,45.83 Z M5.72875,3.12477273 C4.29343773,3.12477273 3.12477273,4.29343773 3.12477273,5.72875 L3.12477273,40.10125 C3.12477273,41.5365623 4.29343773,42.7052273 5.72875,42.7052273 L44.2676136,42.7052273 C45.7029259,42.7052273 46.8715909,41.5365623 46.8715909,40.10125 L46.8715909,5.72875 C46.8715909,4.29343773 45.7029259,3.12477273 44.2676136,3.12477273 L5.72875,3.12477273 Z",
    id: "Shape",
    fill: "#1E4E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4339773,10.4159091 L1.56238636,10.4159091 C0.699949091,10.4159091 0,9.71596 0,8.85352273 C0,7.99108545 0.699949091,7.29113636 1.56238636,7.29113636 L48.4339773,7.29113636 C49.2964145,7.29113636 49.9963636,7.99108545 49.9963636,8.85352273 C49.9963636,9.71596 49.2964145,10.4159091 48.4339773,10.4159091 Z",
    id: "Path",
    fill: "#1E4E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8517045,24.9981818 L29.6853409,24.9981818 C28.8229036,24.9981818 28.1229545,24.2982327 28.1229545,23.4357955 C28.1229545,22.5733582 28.8229036,21.8734091 29.6853409,21.8734091 L32.2893182,21.8734091 L32.2893182,19.2694318 C32.2893182,18.4069945 32.9892673,17.7070455 33.8517045,17.7070455 C34.7141418,17.7070455 35.4140909,18.4069945 35.4140909,19.2694318 L35.4140909,23.4357955 C35.4140909,24.2982327 34.7141418,24.9981818 33.8517045,24.9981818 Z",
    id: "Path",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1446591,36.4556818 C15.2822218,36.4556818 14.5822727,35.7557327 14.5822727,34.8932955 L14.5822727,30.7269318 C14.5822727,29.8644945 15.2822218,29.1645455 16.1446591,29.1645455 L20.3110227,29.1645455 C21.17346,29.1645455 21.8734091,29.8644945 21.8734091,30.7269318 C21.8734091,31.5893691 21.17346,32.2893182 20.3110227,32.2893182 L17.7070455,32.2893182 L17.7070455,34.8932955 C17.7070455,35.7557327 17.0070964,36.4556818 16.1446591,36.4556818 Z",
    id: "Path",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5404636,26.0397727 C16.3883914,26.0397727 16.2363191,26.0168577 16.0842468,25.9731109 C15.2593068,25.7210459 14.7926741,24.8481927 15.0447391,24.0211695 C16.3863082,19.6214895 20.3860173,16.6654545 24.9981818,16.6654545 C28.8520682,16.6654545 32.3663959,18.7798841 34.1704314,22.18172 C34.5745686,22.9441645 34.2850064,23.8899291 33.5225618,24.2961495 C32.7622005,24.6940373 31.8143527,24.4107245 31.4102155,23.6461968 C30.1478073,21.2672032 27.6917359,19.7902273 24.9981818,19.7902273 C21.7713332,19.7902273 18.9715368,21.8567436 18.034105,24.9336032 C17.8299532,25.6064709 17.2112482,26.0397727 16.5404636,26.0397727 Z",
    id: "Path",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9981818,37.4972727 C21.1442955,37.4972727 17.6299677,35.3828432 15.8259323,31.9810073 C15.421795,31.2185627 15.7113573,30.2727982 16.4738018,29.8665777 C17.2383295,29.4707732 18.1820109,29.7540859 18.5861482,30.5165305 C19.8485564,32.8955241 22.3046277,34.3725 24.9981818,34.3725 C28.208365,34.3725 31.0081614,32.3039005 31.9643418,29.2207914 C32.2205732,28.3979345 33.0955095,27.9354682 33.9183664,28.1937827 C34.7433064,28.4479309 35.2036895,29.3249505 34.9474582,30.1478073 C33.5850573,34.5433209 29.5853482,37.4972727 24.9981818,37.4972727 Z",
    id: "Path",
    fill: "#009688"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.d63d1d29.svg";
export { ForwardRef as ReactComponent };